import { Display } from '../enums';

export default class NavigationUtils {
	static LoaderShow() {
		document.querySelector('body').classList.add('page-loader-show');
		const insertInside = '.page-loader';
		const loaderHtml = `
	<div class="loader-overlay">
		<div class="loader-content">
		<div class="loader-index">
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		</div>
	</div>`;

		if (document.querySelectorAll(insertInside).length !== 0) {
			let target = document.querySelector(insertInside);
			if (target) target.insertAdjacentHTML('beforeend', loaderHtml);
		}
	}

	/**
	 * Remove loader
	 */
	static LoaderHide() {
		let el = document.querySelector('.loader-overlay');
		if (!el) return;
		document.querySelector('body').classList.remove('page-loader-show');
		el.parentNode.removeChild(el);
	}

	static createAndOpenPanel(url, reload = false) {
		// Create the overlay
		const overlay = document.createElement('div');
		overlay.id = 'overlay';
		overlay.style.position = 'fixed';
		overlay.style.top = 0;
		overlay.style.left = 0;
		overlay.style.width = '100%';
		overlay.style.height = '100%';
		overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
		overlay.style.zIndex = 2000;

		// Create the panel
		const panel = document.createElement('div');
		panel.id = 'panel';
		panel.style.position = 'fixed';
		panel.style.top = '50%';
		panel.style.left = '50%';
		panel.style.transform = 'translate(-50%, -50%)';
		panel.style.width = '90%';
		panel.style.height = '90%';
		panel.style.backgroundColor = '#fff';
		panel.style.zIndex = 2100;

		// Create the iframe
		const iframe = document.createElement('iframe');
		iframe.src = url;
		iframe.style.width = '100%';
		iframe.style.height = '100%';
		iframe.style.border = 'none';
		iframe.style.display = 'block';
		iframe.style.margin = '0 auto';

		// Create the close button
		const closeButton = document.createElement('div');
		closeButton.id = 'close-popup';
		closeButton.className = 'btn-default btn btn-floating back-link';
		closeButton.title = 'Chiudi';
		closeButton.setAttribute('data-toggle', 'tooltip');
		closeButton.setAttribute('data-original-title', 'Chiudi');

		const closeIcon = document.createElement('i');
		closeIcon.className = 'icon fa-solid fa-xmark';
		closeIcon.setAttribute('aria-hidden', 'true');

		closeButton.appendChild(closeIcon);
		closeButton.style.position = 'absolute';
		closeButton.style.top = '5px';
		closeButton.style.left = '5px';
		closeButton.style.width = '3rem';
		closeButton.style.height = '3rem';
		closeButton.style.cursor = 'pointer';
		closeButton.style.color = '#76838f !important';

		// Loader inside the panel while iframe loads
		const panelLoader = document.createElement('div');
		panelLoader.className = 'loader-overlay';
		panelLoader.innerHTML = '<div class="loader-content"><div class="loader-index"><div></div><div></div><div></div><div></div><div></div><div></div></div></div>';
		panelLoader.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#fff;z-index:3';
		panel.style.overflow = 'hidden';
		panel.appendChild(panelLoader);

		iframe.addEventListener('load', () => {
			// Remove the iframe's own page loader to avoid the double
			try {
				const iframeBody = iframe.contentDocument?.body;
				if (iframeBody) {
					iframeBody.classList.remove('page-loader-show');
					const iframeLoader = iframeBody.querySelector('.loader-overlay');
					if (iframeLoader) iframeLoader.remove();
				}
			} catch (e) {}
			panelLoader.remove();
		});

		// Append elements
		panel.appendChild(iframe);
		panel.appendChild(closeButton);
		overlay.appendChild(panel);
		document.body.appendChild(overlay);

		function closePopup() {
			document.body.removeChild(overlay);
			window.dispatchEvent(new CustomEvent('popup-closed'));
			if (reload) {
				window.location.reload();
			} else {
				console.info('Chiusura comunicazione con popup');
				window.removeEventListener('message', messageHandler);
			}
		}

		function messageHandler(event) {
			if (event.data === 'close' || event.data?.action === 'close') {
				const success_message =
					typeof event.data === 'object' && event.data?.message ? event.data.message : 'Email di prova inviata';
				if (window.toastr) {
					window.toastr.success(success_message);
				}
				closePopup();
			} else if (event.data?.action === 'close-with-error') {
				if (window.toastr && event.data?.message) {
					window.toastr.error(event.data.message);
				}
				closePopup();
			} else if (event.data?.action === 'preview-error' && event.data?.message) {
				if (window.toastr) {
					window.toastr.error(event.data.message);
				}
			} else if (event.data === 'allowClose' || event.data === 'preventClose') {
				if (event.data === 'allowClose') {
					closePopup();
				} else if (event.data === 'preventClose') {
					bootbox.confirm({
						message: 'Potrebbe esserci del lavoro non salvato. Sei sicuro di voler chiudere la pagina?',
						callback: function (result) {
							if (result) {
								iframe.contentWindow.postMessage({ action: 'setNeedsConfirm', value: false }, '*');
								iframe.contentWindow.postMessage('requestClose', '*');
							}
						},
					});
				}
			} else if (event.data === 'ping') {
				console.info('handshake window/popup effettuato');
				iframe.contentWindow.postMessage('pong', '*');
			} else if (event.data === 'changelogRead') {
				setLastVersion(window.version);
				checkForUpdates();
			}
		}

		window.addEventListener('message', messageHandler);

		console.info('Inizializzato protocollo richiesta requestClose');

		closeButton.addEventListener('click', function () {
			iframe.contentWindow.postMessage('requestClose', '*');
		});
	}

	/**
	 * Build a "back" URL pointing at the current page without its filter query string.
	 * Filters are persisted server-side (UserFiltersHandler) and restored on the bare index URL,
	 * so the back URL must only carry the path plus `locale` (which is read from the URL each request).
	 *
	 * @returns {string}
	 */
	static getCleanBackUrl() {
		const url = new URL(window.location.pathname, window.location.origin);
		const current_params = new URLSearchParams(window.location.search);

		for (const key of ['locale', 'popup', 'offcanvas']) {
			const value = current_params.get(key);

			if (value) {
				url.searchParams.set(key, value);
			}
		}

		return url.toString();
	}

	/**
	 * Append a `back` param pointing at the current (filter-less) page to a target URL.
	 * Centralises the encode + `?`/`&` delimiter handling so call sites never rebuild it by hand.
	 *
	 * @param {string} targetUrl URL to navigate to (may already carry a query string)
	 * @returns {string}
	 */
	static withBackUrl(targetUrl) {
		const url = new URL(targetUrl, window.location.origin);
		url.searchParams.set('back', NavigationUtils.getCleanBackUrl());

		return url.toString();
	}

	/**
	 * @param {string} url
	 * @param {{ offcanvas?: boolean, display?: string|null }} options
	 */
	static appendPopupQueryParams(url, { offcanvas = false, display = null } = {}) {
		if (!url) {
			return url;
		}

		const parsed_url = new URL(url, window.location.origin);
		parsed_url.searchParams.set('popup', 'true');

		if (offcanvas) {
			parsed_url.searchParams.set('offcanvas', 'true');
		}

		if (display && !parsed_url.searchParams.get('display')) {
			parsed_url.searchParams.set('display', display);
		}

		return parsed_url.toString();
	}

	/**
	 * Build the full-page URL for a sources picker opened in a detached browser tab.
	 *
	 * @param {string} url
	 * @param {string} sessionId
	 * @returns {string}
	 */
	static buildDetachedSourcesPickerUrl(url, sessionId) {
		if (!url || !sessionId) {
			throw new Error('url and sessionId are required');
		}

		const parsed = new URL(url, window.location.origin);
		parsed.searchParams.set('popup', 'true');
		parsed.searchParams.set('detached', '1');
		parsed.searchParams.set('picker_session', sessionId);

		// Keep offcanvas=true so existing sources scripts that gate drag UI still run.
		if (!parsed.searchParams.has('offcanvas')) {
			parsed.searchParams.set('offcanvas', 'true');
		}

		if (!parsed.searchParams.get('display')) {
			parsed.searchParams.set('display', Display.CARD_ESSENTIAL);
		}

		return parsed.toString();
	}

	static openUrlInOffcanvas(url, title = null) {
		if (url) {
			url = NavigationUtils.appendPopupQueryParams(url, {
				offcanvas: true,
				display: Display.CARD_ESSENTIAL,
			});
		}
		document.dispatchEvent(new CustomEvent('openOffcanvas', { detail: { data: { action: url ? 'iframe' : 'empty', url, title } } }));
	}

	static getAppHostSuffix() {
		if (window.appconfig?.general?.appHostSuffix) {
			return window.appconfig.general.appHostSuffix.toLowerCase();
		}

		const host = window.location.hostname.toLowerCase();
		const dot = host.indexOf('.');

		return dot === -1 ? host : host.slice(dot + 1);
	}

	static hostBelongsToApp(host) {
		const normalized = host.toLowerCase();
		const suffix = NavigationUtils.getAppHostSuffix();

		return normalized === suffix || normalized.endsWith('.' + suffix);
	}

	static shouldProxyStreamUrl(url) {
		if (!url || !/^https?:\/\//i.test(url)) {
			return false;
		}

		try {
			return !NavigationUtils.hostBelongsToApp(new URL(url).hostname);
		} catch {
			return false;
		}
	}

	static getProxyStreamUrl(url, force = false) {
		if (force) {
			// Force proxying even for app-host URLs: they may redirect to a CDN
			// without CORS headers, which taints a canvas on cross-origin capture.
			if (!url || !/^https?:\/\//i.test(url)) {
				return url;
			}
		} else if (!NavigationUtils.shouldProxyStreamUrl(url)) {
			return url;
		}

		return window.appconfig.routes.files.stream + '?proxyurl=' + encodeURIComponent(btoa(url));
	}
}
